module.exports = function(app) {
    app.directive('filterBoxAndTableDisplay', ['teamsite', 'services', '$window', 'invisibleForm', 'sessionData','$filter',
        function (teamsite, services, $window, invisibleForm, sessionData,$filter) {
            return {
                restrict: 'A',
                replace: true,
                template: require('directives/common/filterBoxAndTableDisplay.html'),
                controller: [function () {
                }],
                link: function (scope, element, attrs) {
                    scope.brandName = sessionData.employerInfo.brandName;
                    scope.callingPage = {
                        isBeneBooks: false,
                        isSbc: false,
                        isGroupContracts: false,
                        isPreventiveMedications: false
                    };
                    var theCallingPage = attrs.filterBoxAndTableDisplay; // == 'bene-books'
                    switch (theCallingPage) {
                        case 'bene-books':
                            scope.callingPage.isBeneBooks = true;
                            break;
                        case 'summary-of-benes':
                            scope.callingPage.isSbc = true;
                            break;
                        case 'group-contracts':
                            scope.callingPage.isGroupContracts = true;
                            break;
                        case 'preventive-medications':
                            scope.callingPage.isPreventiveMedications = true;
                            break;
                    }

                    // BEGIN HIT SECOND SBC SERVICE ================================================================
                    scope.arrPlansToEvaluate = [];
                    scope.intArrPlanToEvaluate = 0;
                    var getNextMetaDataOrNot = function() {
                        if(scope.intArrPlanToEvaluate < (scope.arrPlansToEvaluate.length - 1)) {
                            scope.intArrPlanToEvaluate += 1;
                            scope.getSbcMetaData();
                        } else {
                            scope.serviceCallIsRunning = false;
                            if (scope.objFiltering.arrItems.length == 0) {
                                if (scope.brandName == '6008') {
                                    scope.feedback.showFeedback('We are sorry for the inconvenience. Please contact Customer Service at 1-800-ASK-Blue to obtain information regarding your summary of benefits and coverage.', 'notification');
                                } else
                                if (scope.brandName == '6009') {
                                    scope.feedback.showFeedback('We are sorry for the inconvenience. Please contact Customer Service at 1-877-219-5453 to obtain information regarding your summary of benefits and coverage.', 'notification');
                                } else
                                {
                                    scope.feedback.showFeedback('Your summary of benefits is currently not available. Please contact customer service or account executive for more information.', 'notification');
                                }
                            }
                        }
                    }
                    scope.getSbcMetaData = function() {
                        var p = scope.arrPlansToEvaluate[scope.intArrPlanToEvaluate];
                        //  effectiveDate:"04/14/2017"
                        //  erisa:"No"
                        //  groupNumber:"10186824"
                        //  planName:"BluePrint PLT $1000 (ABH6) area 8 OFFX Blue Plus"
                        //  productId:"2097811374"
                        var sbcParams = {};
                        sbcParams.brand = sessionData.employerInfo.brandName;
                        sbcParams.payload = {
                            productId: p.productId,   //curPrd.superProductNumber, //productList[scope.iPrdIdx].productNumber ,
                            isErisaIndicator: p.erisa.toUpperCase(),   //curGrp.erisaIndicator,
                            groupNumber: p.groupNumber,    //curGrp.groupNumber,
                            effectiveCoverageDate: p.effectiveDate     // curPrd.coverageBeginDate
                        };
                        services.rbsmbl.summaryOfBenesRbsmbl().fetch(sbcParams).then(

                            function (dataSbcMetaInfo) {
                                scope.serviceReturnedItems = true;
                                scope.secondServiceIsRunning = true;
                                //dataSbcSvc1.data.payload: Object
                                //    effectiveCoverageDate: "04/13/2017"
                                //    fileName: "product/2097810549/I_2097810549_20160101_SBC.pdf"
                                //    marketSegment: "Direct Pay"
                                //    size: "218206"
                                var displayInfo = {
                                    planName: p.planName,
                                    docId: dataSbcMetaInfo.data.payload.docId,
                                    groupNumber: p.groupNumber,
                                    fullUrl: dataSbcMetaInfo.data.payload.fileName,
                                    effectiveDate: p.effectiveDate,
                                    erisa: p.erisa,
                                    productId: p.productId,
                                    marketSegment: dataSbcMetaInfo.data.payload.marketSegment
                                };
                                scope.objFiltering.arrItems.push(displayInfo);
                                getNextMetaDataOrNot();
                            },
                            function (err) {
                                if (err.data && err.data.baseMessage && err.data.baseMessage.returnCodeDescription ) {
                                    var desc = err.data.baseMessage.returnCodeDescription;
                                    if (desc.indexOf('No SBC List')>-1) {
                                        var startPos = desc.indexOf('No SBC List');
                                    } else {
                                       // console.log(desc);
                                    }
                                } else {
                                    // console.log(err.status + ', ' + err.statusText)
                                }
                                getNextMetaDataOrNot();
                            } ) }
                    // END HIT SECOND SBC SERVICE ===================================================================
                    var enhanceMedLists = function(theMedLists) {
                        // Changes for PM78644
                        var theHostName = 'https://' + window.location.hostname;
                        theHostName = theHostName.split('denv').join('tenv');
                        for (var i =0; i < theMedLists.length; i++) {
                            theMedLists[i].fullURL = theHostName + theMedLists[i].fullURL;
                            // theMedLists[i].planNameAndGroupNumber = theMedLists[i].planName + theMedLists[i].groupNumber;
                        }
                        return theMedLists;
                    }
                    var handleServiceSuccess = function(retObj) {
                        if (retObj && retObj.data && retObj.data.payload && retObj.data.payload.length) {
                            if (retObj.data.payload.length > 0) {
                                if (scope.callingPage.isSbc) {
                                    scope.arrPlansToEvaluate = retObj.data.payload;
                                    scope.getSbcMetaData();
                                } else {
                                    scope.serviceCallIsRunning = false;
                                    scope.serviceReturnedItems = true;
                                    if (scope.callingPage.isPreventiveMedications) {
                                        var arrWithFixedUrl = enhanceMedLists(retObj.data.payload);
                                        scope.objFiltering.arrItems = arrWithFixedUrl;
                                        // scope.$apply();
                                    } else {
                                        scope.objFiltering.arrItems = retObj.data.payload;


                                    }
                                }
                            } else {
                                scope.serviceCallIsRunning = false;
                                scope.feedback.showFeedback("The service returned no items.", "failure");
                            }
                        } else {
                            scope.serviceCallIsRunning = false;
                            scope.feedback.showFeedback("The service returned something unexpected.", "failure");
                            $($window).scrollTop(0);
                        }
                    }
                    var handleServiceFailure = function(err) {
                        scope.serviceReturnedItems = false;
                        scope.serviceCallIsRunning = false;
                        if (err.data && err.data.baseMessage && err.data.baseMessage.returnCodeDescription) {
                            console.error(err.data.baseMessage.returnCodeDescription)
                            var theMsg = 'Preventive medications list is currently not available for this client.';
                            theMsg = (scope.callingPage.isBeneBooks) ? 'We\'re sorry... your benefit booklet is not available. Please contact your plan administrator or customer service for questions regarding your benefit information.' : theMsg;

                            if (scope.callingPage.isGroupContracts) {
                                switch (scope.brandName) {
                                    //case 'HMBCBS', 'IBCCR', 'IBCAH':
                                    //    theMsg = "We're sorry. Your group contracts are currently not available. Contracts are available from 60 to 90 days after the effective date. You may contact your Account Executive to request a contract."
//                                        break;
                                    case "6010":
                                        theMsg = "A Master Group Contract cannot be located for your organization.Please contact Group Leader Line at 1-877-293-7035 or Agency Services at 1-800-262-0821, or your Blue Cross sales consultant."
                                        break;
                                    default:
                                        theMsg = "We're sorry. Your group contracts are currently not available. Contracts are available from 60 to 90 days after the effective date. You may contact your Account Executive to request a contract."
                                        break;
                                }
                            }
                            if (scope.callingPage.isSbc) {
                                switch (scope.brandName) {
                                    case "6008":
                                        // IBC
                                        theMsg = "We are sorry for the inconvenience.  Please contact Customer Service at 1-800-ASK-Blue to obtain information regarding your summary of benefits and coverage."
                                        break;
                                    case "6009":
                                        // AHNJ
                                        theMsg = "We are sorry for the inconvenience.  Please contact Customer Service at 1-877-219-5453 to obtain information regarding your summary of benefits and coverage."
                                        break;
                                    default:
                                        theMsg = 'Your summary of benefits is currently not available. Please contact customer service or account executive for more information.';
                                        break;
                                }
                            }
                            scope.feedback.showFeedback(theMsg, "notification");
                            $($window).scrollTop(0);
                        } else {
                            scope.feedback.showFeedback("We are unable to process the request right now, Please try again later.", "failure");
                            $($window).scrollTop(0);
                        }
                    }
                    var getItemsFromService = function() {
                        // TODO: name the variables more generically
                        // TODO: b c this is used in three pages, not just Bene Books
                        scope.serviceCallIsRunning = true;
                        scope.serviceReturnedItems = false;
                        if (scope.callingPage.isBeneBooks) {
                            services.eprsvc.benefitBooklets().submitSearch().then(function (retObj) {
                                handleServiceSuccess(retObj);
                            }, function (err) {
                                handleServiceFailure(err);
                            });
                        } else
                        if (scope.callingPage.isSbc) {
                            services.eprsvc.summaryOfBenes().submitSearch().then(function (retObj) {
                                handleServiceSuccess(retObj);
                            }, function (err) {
                                handleServiceFailure(err);
                            });
                        } else
                        if (scope.callingPage.isGroupContracts) {
                            services.eprsvc.groupContracts().submitSearch().then(function (retObj) {
                                handleServiceSuccess(retObj);
                            }, function (err) {
                                handleServiceFailure(err);
                            });
                        } else
                        if (scope.callingPage.isPreventiveMedications) {
                            if (sessionData.entitlements.employees.view) {
                                services.eprsvc.preventiveMedications().getPreventiveMedications().then(function (retObj) {
                                    handleServiceSuccess(retObj);
                                }, function (err) {
                                    handleServiceFailure(err);
                                });
                            } else {
                                scope.serviceReturnedItems = false;
                                scope.serviceCallIsRunning = false;
                                scope.feedback.showFeedback('You do not have permissions to view this info.', 'notification');
                                return;
                            }
                        }  else {
                            scope.serviceCallIsRunning = false;
                            console.error('Calling page not recognized');
                            alert('Calling page not recognized');
                        }
                    }
                    getItemsFromService();

                    scope.CMODDownlodPDF= function(document) {
                        var test = [];
                        test = document.split("_");
                        var keytooPas = test[1];
                        var test2split = test[2].split(".");
                        var odFolder = "CHM-HM-3COM-BB-CONTRACT-RIDERS";
                        var userId = "appchm";
                        beginDate = $filter('date')(new Date(new Date().setFullYear(new Date().getFullYear() - 3)),"MM-dd-yyyy");
                        endDate=$filter('date')(new Date(),"MM-dd-yyyy");
                        var key1 = "C";
                        var key2 = test[0];
                        var key3="";
                        var key4 = keytooPas;
                        var key5 = test2split[0];



                        var theParamsEtc = '/'+ beginDate + '/' + endDate ;
                        console.log(theParamsEtc);

                        var GetCMODFormConfig = {
                            name: "cmodDocument",
                            target: "_blank",
                            method: "GET",
                            action: "/eprsvc/x-services/secure/documents/v1/CMOD-document/groupContracts"+theParamsEtc,
                            inputs: {

                                                            key1: key1,
                                                            key2: key2,
                                                            key3: key3,
                                                            key4:key4,
                                                            key5: key5

                            }
                        };
                        setTimeout(function () {
                            invisibleForm.submit(GetCMODFormConfig);
                        }, 500);
                    };
                    scope.CMODDownlodPDFBen= function(document) {
                        // var test = [];
                        // test = document.split("_");
                        // var keytooPas = test[1];
                        // var test2split = test[2].split(".");
                        var odFolder = "CHM-HM-3COM-BB-CONTRACT-RIDERS";
                        var userId = "appchm";
                        beginDate = $filter('date')(new Date(new Date().setFullYear(new Date().getFullYear() - 3)),"MM-dd-yyyy");
                        endDate=$filter('date')(new Date(),"MM-dd-yyyy");
                        var key1 = document['cmodK1Type'];
                        var key2 = document['cmodK2Prefix'];
                        var key3="";
                        var key4 = document['cmodK4RiderName'];
                        var key5 = document['cmodK5EffDate'];



                        var theParamsEtc ='/' + beginDate + '/' + endDate ;
                        console.log(theParamsEtc);

                        var GetCMODFormConfig = {
                            name: "cmodDocument",
                            target: "_blank",
                            method: "GET",
                            action: "/eprsvc/x-services/secure/documents/v1/CMOD-document/inserts"+theParamsEtc,
                            inputs: {

                                key1: key1,
                                key2: key2,
                                key3: key3,
                                key4:key4,
                                key5: key5

                            }
                        };
                        setTimeout(function () {
                            invisibleForm.submit(GetCMODFormConfig);
                        }, 500);
                    };

                    scope.sbcThirdStep_GetPdf = function(thePlan) {
                        var theInputs = {
                            marketSegment: thePlan.marketSegment,
                            docId: thePlan.docId,
                            fileName: thePlan.fullUrl
                        };
                        var valMarketSegment = thePlan.marketSegment;
                        var valDocId = '';
                        var valFileName = thePlan.fullUrl;
                        var objPayload = {
                            marketSegment: valMarketSegment,
                            docId: thePlan.docId,
                            fileName: valFileName
                        };

                        var GetSbcFormConfig = {
                            name: "GetSbcDocForm",
                            id: "GetSbcDocFormId",
                            formTarget: "GetSbcDocSvcsWindow",
                            method: "POST",
                            action: "/rbsmbl/x-services/sbcAllGroups/file",
                            inputs: {
								payload: JSON.stringify({
									marketSegment: valMarketSegment,
									docId: thePlan.docId,
									fileName: valFileName
								})
							}
                        };
                        setTimeout(function () {
                            invisibleForm.submit(GetSbcFormConfig);
                        }, 500);
                    };
                }
            };
        }]);

}
